import { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import { useGetUsageData } from './UsageMonitor'
import { fetchUsageMonitorConfig } from '../api/usage-monitor'

/**
 * Shared state and logic for usage monitor report pages.
 */
export const useUsageMonitorPage = () => {
  const [plantFilter, setPlantFilter] = useState(null)
  const [userIdentifier, setUserIdentifier] = useState('user_id')
  const [selectedUser, setSelectedUser] = useState(null)
  const [selectedDate, setSelectedDate] = useState(null)
  const [startTimeFilter, setStartTimeFilter] = useState(
    dayjs().subtract(1, 'day'),
  )
  const [endTimeFilter, setEndTimeFilter] = useState(dayjs())
  const [sortedData, setSortedData] = useState({})
  const [lastUpdatedTime, setLastUpdatedTime] = useState(new Date())

  const { allUsageData, isLoading, refetch } = useGetUsageData(
    startTimeFilter,
    endTimeFilter,
  )

  useEffect(() => {
    fetchUsageMonitorConfig().then((config) => {
      if (config?.user_identifier) {
        setUserIdentifier(config.user_identifier)
      }
    })
  }, [])

  return {
    plantFilter,
    setPlantFilter,
    userIdentifier,
    selectedUser,
    setSelectedUser,
    selectedDate,
    setSelectedDate,
    startTimeFilter,
    setStartTimeFilter,
    endTimeFilter,
    setEndTimeFilter,
    sortedData,
    setSortedData,
    lastUpdatedTime,
    setLastUpdatedTime,
    allUsageData,
    isLoading,
    refetch,
  }
}
